
function Home(){
    return <h1>Menu</h1>
}
export default Home